import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import styles from '../utils/AnalystReportsStyle.module.scss';
import bannerImage from '../../../assets/BannerImage.svg';
import tubesIcon from '../../../assets/tubesIcon.svg';
import { getDesktopVersion } from '../../ComponentNavBar/redux/dashboardSlice';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';
import AnalystSelfTubeCountModal from '../../ComponentNavBar/AnalystSelfTubeCountModal ';
import ShowAnalystReportModal from '../../ComponentNavBar/ShowAnalystReportModal';

function ReportsDashBoard() {
  const dispatch = useDispatch();
  const [showAnalystReportModal, setShowAnalystReportModal] = useState<boolean>(false);
  const [showAnalystModal, setShowAnalystModal] = useState<boolean>(false);
  const { version, isVersionLoading } = useSelector((state: RootState) => state.dashboardReducer);
  useEffect(() => {
    dispatch(getDesktopVersion());
  }, []);

  useEffect(() => {
    dispatch(setLoader(isVersionLoading));
  }, [isVersionLoading]);

  return (
    <>
      <ComponentPageHeader
        subHeading="Dashboard"
        version={version}
        versionLabel="Current Desktop Version"
      />
      <div className={`${styles.dashboardCardWrapper} div_job_container_info`}>
        <div className="dashboardBanner"><img src={bannerImage} alt="Banner" height={200} /></div>
      </div>
      <div
        style={{
          minHeight: '117px', width: '40%', marginLeft: '30px', marginTop: '20px',
        }}
        className="dashboardCardContainer pointCursor"
        onClick={() => { setShowAnalystModal(true); }}
      >
        <div className="dashboardCardIcon blue">
          <img src={tubesIcon} alt="icon" height={40} width={40} />
        </div>
        <div className="dashboardCardContent">
          <div className="dashboardCardText">Analyst Tube Count</div>
        </div>
      </div>
      <div className="footer">
        Copyright © 2023 &nbsp;
        <Link to="http://taiservices.com/" target="_blank">Taiservices</Link>
        . Designed by&nbsp;
        <Link to="https://binmile.com/" target="_blank">Binmile Technologies Private Limited</Link>
        .&nbsp;All rights reserved.
      </div>
      {showAnalystModal && (
      <AnalystSelfTubeCountModal
        open={showAnalystModal}
        handleClose={() => setShowAnalystModal(false)}
        handleReportDisplay={() => setShowAnalystReportModal(true)}
      />
      )}
      {showAnalystReportModal && (
      <ShowAnalystReportModal
        open={showAnalystReportModal}
        handleClose={() => setShowAnalystReportModal(false)}
      />
      )}
    </>
  );
}

export default ReportsDashBoard;
